export default window => /bot|google|phantom|crawler|spider|crawling|headless|^mozilla\/4\.0$/i.test(window.navigator.userAgent)


// WEBPACK FOOTER //
// ./~/santa-main-r/src/main/lib/common/isBot.js